import { render, staticRenderFns } from "./goodsTypeAvgPrice.vue?vue&type=template&id=2eaa1364&"
import script from "./goodsTypeAvgPrice.vue?vue&type=script&lang=js&"
export * from "./goodsTypeAvgPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports